import { menuItemsPart1 } from './menuItems1';
import { menuItemsPart2 } from './menuItems2';
import { menuItemsPart3 } from './menuItems3';

export const menuCategories = [
  { id: 'tea', key: 'tea' },
  { id: 'shakes', key: 'shakes' },
  { id: 'snacks', key: 'snacks' },
  { id: 'chaat', key: 'chaat' },
  { id: 'starters', key: 'starters' },
  { id: 'chinese', key: 'chinese' },
  { id: 'raita', key: 'raita' },
  { id: 'pizza', key: 'pizza' },
  { id: 'sweets', key: 'sweets' },
  { id: 'mainVeg', key: 'mainVeg' },
  { id: 'nonVeg', key: 'nonVeg' },
  { id: 'rice', key: 'rice' },
  { id: 'breads', key: 'breads' },
  { id: 'combo', key: 'combo' },
];

export interface MenuItem {
  id: string;
  category: string;
  name: string;
  desc: string;
  price: string;
  priceValue: number;
  image: string;
}

export const menuItems: MenuItem[] = [
  ...menuItemsPart1,
  ...menuItemsPart2,
  ...menuItemsPart3,
];

export interface GalleryImage {
  id: string;
  title: string;
  image: string;
}

export const galleryImages: GalleryImage[] = [
  {
    id: 'g1',
    title: 'Warm & inviting interior',
    image: 'https://readdy.ai/api/search-image?query=elegant%20warm%20Indian%20restaurant%20interior%20with%20hanging%20amber%20lights%2C%20carved%20wooden%20panels%20and%20red%20accents%2C%20cozy%20moody%20ambiance%2C%20golden%20glow%2C%20sophisticated%20dining%20atmosphere&width=800&height=1000&seq=gallery-01&orientation=portrait',
  },
  {
    id: 'g2',
    title: 'Open flame tandoor kitchen',
    image: 'https://readdy.ai/api/search-image?query=open%20flame%20tandoor%20kitchen%20with%20chef%20cooking%20Indian%20bread%20and%20kebabs%2C%20fire%20and%20sparks%2C%20dramatic%20warm%20lighting%2C%20culinary%20craft%20in%20motion%2C%20rich%20amber%20and%20smoke&width=800&height=1000&seq=gallery-02&orientation=portrait',
  },
  {
    id: 'g3',
    title: 'Colorful chaat counter',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20Indian%20chaat%20street%20food%20counter%20with%20colorful%20bowls%20of%20chutneys%20and%20spices%2C%20warm%20golden%20evening%20light%2C%20bustling%20festive%20atmosphere&width=800&height=1000&seq=gallery-03&orientation=portrait',
  },
  {
    id: 'g4',
    title: 'Fresh spices and herbs',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20display%20of%20colorful%20Indian%20spices%20cumin%20turmeric%20coriander%20cardamom%20in%20brass%20bowls%2C%20vibrant%20colors%2C%20warm%20natural%20light%2C%20aromatic%20kitchen%20ingredients%2C%20culinary%20photography&width=800&height=1000&seq=gallery-04&orientation=portrait',
  },
];

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  text: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Ani Karapetyan',
    role: 'Local food blogger',
    text: 'Mehfil is my late-night spot. The paneer tikka is hands down the best in Yerevan, and the fact that they are open 24/7 is a lifesaver.',
    rating: 5,
  },
  {
    id: 't2',
    name: 'David Hakobyan',
    role: 'Regular guest',
    text: 'Ordered the pav bhaji for delivery at 2am and it arrived hot and perfectly packed. The samosa chaat tastes just like Mumbai.',
    rating: 5,
  },
  {
    id: 't3',
    name: 'Sona Petrosyan',
    role: 'Tourist from Moscow',
    text: 'Beautiful atmosphere, friendly staff and incredible mango milkshake. The Indo-Chinese menu here is something you cannot find anywhere else in Yerevan.',
    rating: 5,
  },
];